import GoogleTrackingEvents from './../../../../../Mozo.Digon/Resources/Private/Styleguide/js/googleTrackingEvents';

document.querySelector('html').classList.remove('no-js');

var inFrame = function () {
    return !(window === window.parent);
};

if (!inFrame()) {
    new GoogleTrackingEvents().init();
}
